import React from 'react';
import {Avatar, Button, Col, Flex, Row} from "antd";
import {CollapsedIcon} from "../../assets/image/svg";
import { useSelector } from 'react-redux';
import { RootState } from '../../store';


interface SiderComponentProps {
    setCollapsed: (value: (((prevState: boolean) => boolean) | boolean)) => void,
    collapsed: boolean
}


const Index = ({setCollapsed, collapsed}: SiderComponentProps) => {
    const userInfoData: any = useSelector((state: RootState) => state.users.userInfoData);

    return (
        <Flex justify="space-between" align="center" className={'sider__header'} gap={10}>
            <Row justify="space-between" align="middle">
                <Col span={6}>
                    <Avatar size={!collapsed ? 36 : 42}  src={userInfoData?.avatar}/>
                </Col>
                    {!collapsed &&
                        <>
                            <Col span={12}>
                                <h3>{userInfoData?.name}</h3>
                            </Col>
                            <Col span={6}>
                                <Button type="text" style={{marginRight: 10}} icon={<CollapsedIcon/>}
                                        onClick={() => setCollapsed(!collapsed)}
                                />
                            </Col>
                        </>
                    }
            </Row>
        </Flex>
    );
};

export default Index;
